export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM10 5.21 14.79 10H5.21zM17 15c0-1.33 1-1.75 2-3.5 0 0 2 2.17 2 3.5 0 1.1-.9 2-2 2s-2-.9-2-2M0 20h24v4H0z\"/>"
};